<template>
  <div
    :class="[
      'productTile',
      { 'productTile--mobile': $device.isMobileOrTablet },
      { 'productTile--multiPacks': isMultiPacks },
      { 'productTile--oldPrice': productData.priceBeforeDiscountObject },
      {
        'productTile--isFromMyOffer': productData.isFromMyOffer || productData.isFromCatalogSubset,
      },
    ]"
  >
    <div class="productTile__inner">
      <button v-if="disableNativeLink" class="productTile__link" @click="gTagProductClick"></button>
      <nuxt-link
        v-else
        :to="localePath({ name: 'product-slug', params: { slug: productData.slug } })"
        class="productTile__link"
        @click.native="gTagProductClick"
      />
      <div class="productTile__header">
        <div class="productTile__headerLeft">
          <div v-if="productData.sponsoredOfferInfo" class="productTile__headerOffer">
            <span class="productTile__headerOfferText"> Oferta sponsorowana </span>
            <client-only>
              <v-popover :placement="$device.isMobile ? 'left' : 'top'" trigger="hover" offset="10">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
                  <g id="Group_23452" data-name="Group 23452" transform="translate(-255.5 -185.5)">
                    <circle
                      id="Ellipse_242"
                      data-name="Ellipse 242"
                      cx="7.5"
                      cy="7.5"
                      r="7.5"
                      transform="translate(256.5 186.5)"
                      fill="none"
                      stroke="#abb0b9"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    />
                    <path
                      id="Path_11538"
                      data-name="Path 11538"
                      d="M12.651,14.605h-.888V11.25h-.888"
                      transform="translate(252.237 182.158)"
                      fill="none"
                      stroke="#abb0b9"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    />
                    <path
                      id="Path_11539"
                      data-name="Path 11539"
                      d="M11.657,8.058h0a.2.2,0,1,1,0,.279.2.2,0,0,1,0-.279"
                      transform="translate(252.084 182.842)"
                      fill="none"
                      stroke="#abb0b9"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    />
                  </g>
                </svg>
                <template slot="popover">
                  <div v-close-popover>
                    <div :class="[{ 'popoverTooltip--mobile': $device.isMobile }]">
                      {{ productData.sponsoredOfferInfo }}
                    </div>
                  </div>
                </template>
              </v-popover>
            </client-only>
          </div>
          <div class="productTile__headerBadges">
            <product-badges
              v-if="productData.badges && productData.badges.length"
              :badges="productData.badges"
              inline
            />
          </div>
        </div>
        <product-actions :is-on-list="isOnShoppingList" :product="productData" />
      </div>
      <div
        class="productTile__image"
        :class="[
          'productTile__image',
          {
            'productTile__image--largeMobile': !isMultiPacks,
          },
        ]"
      >
        <new-image-box
          :alt="productData.name"
          background-color="#fff"
          :src="productData.mainPictureUrl"
          :width="250"
          :height="250"
          fit-contain-center
          image-params="w_350,h_350"
        />
      </div>
      <div class="productTile__content">
        <!--        <product-rating-stars :stars="productData.stars" class="productTile__ratings" />-->
        <span v-if="disableNativeLink" v-line-clamp:20="2" class="productTile__name">
          {{ productData.name }}</span
        >
        <h3 v-else v-line-clamp:20="2" class="productTile__name">
          {{ productData.name }}
        </h3>
        <div class="productTile__tags">
          <product-tags :tags="tags" />
        </div>
        <div class="productTile__price">
          <div class="productTile__priceRegular">
            <div v-if="productData.priceBeforeDiscountObject" class="productTile__oldPrice">
              <span class="productTile__discount"
                >-{{
                  $helper.calculateDiscount(
                    showNetPrices
                      ? productData.priceBeforeDiscountObject.net
                      : productData.priceBeforeDiscountObject.gross,
                    showNetPrices ? productData.priceObject.net : productData.priceObject.gross,
                  )
                }}%</span
              >
              <div class="productTile__oldPriceNumber">
                {{ productData.priceBeforeDiscountObject.currencyPrefix
                }}{{
                  showNetPrices
                    ? productData.priceBeforeDiscountObject.netFormatted
                    : productData.priceBeforeDiscountObject.grossFormatted
                }}
                {{ productData.priceBeforeDiscountObject.currencyPostfix }}
                {{ showNetPrices ? $t('net') : $t('gross') }}
              </div>
            </div>
            <span class="productTile__priceRegularNumber"
              >{{ productData.priceObject.currencyPrefix
              }}{{
                showNetPrices
                  ? productData.priceObject.netFormatted
                  : productData.priceObject.grossFormatted
              }}</span
            >
            {{ productData.priceObject.currencyPostfix }}
            {{ showNetPrices ? $t('net') : $t('gross') }}
          </div>
          <div v-if="productData.pricePerBaseUOM?.net" class="productTile__priceUom">
            {{
              showNetPrices ? productData.pricePerBaseUOM.net : productData.pricePerBaseUOM.gross
            }}
          </div>
          <div v-if="productData.priceBeforeDiscountObject" class="productTile__priceInfo">
            Najniższa cena z 30 dni:
            <span v-if="productData.priceBeforeDiscountObject.currencyPrefix">{{
              productData.priceBeforeDiscountObject.currencyPrefix
            }}</span
            >{{ productData.priceBeforeDiscountObject.grossFormatted }}
            <span v-if="productData.priceBeforeDiscountObject.currencyPostfix">{{
              productData.priceBeforeDiscountObject.currencyPostfix
            }}</span>
          </div>
        </div>
        <div class="productTile__cart">
          <div class="productTile__cartInner">
            <div v-if="isMultiPacks" class="productTile__cartMultiPacks">
              <ProductMultiPacksSelect
                :options="preparedOptions"
                :product="productData"
                open-up
                refresh-tile
                @refresh="refreshTile"
              />
            </div>
            <manual-add-to-basket
              :uom="productData.uom !== 'paleta' ? productData.uom : ''"
              @addToBasket="val => cartButtonClickHandler(productData, val)"
              button-text="Do koszyka"
              order-button-text="Do zamówienia"
              :can-be-ordered="productData.canBeOrdered"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="productTile__loader" v-if="isRefreshing">
      <loader />
    </div>
  </div>
</template>

<script>
import slugify from 'slugify';
// import ProductRatingStars from '~/components/Product/ProductRatingStars';
import { VPopover, VClosePopover } from 'v-tooltip';
import { mapState, mapGetters } from 'vuex';
import ProductBadges from './ProductBadges';
import ProductActions from './ProductActions';
import ProductTags from './ProductTags';
import NewImageBox from '@/components/NewImageBox';
import cartMixin from '~/mixins/cart';
import listMixin from '~/mixins/list';
import FormCountInput from '~/components/Form/FormCountInput';
import VButton from '~/components/VButton';
import ImagePlaceholder from '~/components/ImagePlaceholder';
import ProductMultiPacksSelect from '~/components/Product/ProductMultiPacksSelect';
import AddToBasket from '~/components/AddToBasket';
import Loader from '~/components/Loader.vue';
import ManualAddToBasket from '@/components/ManualAddToBasket.vue';

export default {
  name: 'ProductTile',
  components: {
    ManualAddToBasket,
    Loader,
    AddToBasket,
    NewImageBox,
    ProductTags,
    ProductActions,
    ProductBadges,
    FormCountInput,
    ImagePlaceholder,
    VButton,
    VPopover,
    ProductMultiPacksSelect,
    // ProductRatingStars,
  },
  directives: {
    closePopover: VClosePopover,
  },
  mixins: [cartMixin, listMixin],
  props: {
    product: {
      type: Object,
      default: null,
    },
    disableNativeLink: {
      type: Boolean,
      default: false,
    },
    swiperLazyLoad: {
      type: Boolean,
      default: false,
    },
    listName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isOnShoppingList: false,
      productData: this.product,
      firstLoad: true,
      isRefreshing: false,
      disableMultipleButton: true,
      preparedOptions: [],
    };
  },
  computed: {
    ...mapGetters('cart', ['shoppingCartItems']),
    ...mapGetters('auth', ['showNetPrices']),
    ...mapState({
      acl: state => state.auth.acl,
      isMultiPacks() {
        return (
          typeof this.productData.multiPacks !== 'undefined' &&
          Array.isArray(this.productData.multiPacks) &&
          this.productData.multiPacks.length
        );
      },
    }),
    tags() {
      return [
        {
          name: this.$t('code'),
          value: this.productData.code,
        },
        {
          color: this.productData?.availabilityMarkColor.color,
          value: this.productData?.whenProductWillBeAtYourPlace,
        },
      ];
    },
  },
  watch: {
    'acl.showNetPrices'() {
      this.firstLoad = false;
    },
  },
  created() {
    this.isOnShoppingList = this.checkIfInList(this.productData.id);
    this.unwatchShoppingList = this.$store.watch(
      () => (this.$auth.isLogged() ? this.shoppingLists : this.defaultShoppingList),
      newValue => {
        this.isOnShoppingList = this.checkIfInList(this.productData.id);
      },
    );
  },
  mounted() {
    if (this.isMultiPacks) {
      this.preparedOptions = this.$helper.prepareMultiPacks(this.productData);
    }
  },
  beforeDestroy() {
    this.unwatchShoppingList();
  },
  methods: {
    async cartButtonClickHandler(product, count, listName) {
      this.firstLoad = false;
      this.isLoading = true;
      await this.addProductToCart(product, count, false, listName);
      this.isLoading = false;
    },
    gTagProductClick() {
      const item = this.productData;

      const categories = item?.category?.namesInPath.reduce((acc, curr, index) => {
        acc['category' + (index === 0 ? '' : index + 1)] = curr;
        return acc;
      }, {});
      this.$gtm.push({ ecommerce: null });
      this.$gtm.push({
        event: 'select_item',
        ecommerce: {
          item_list_id: slugify(this.listName),
          item_list_name: this.listName,
          items: [
            {
              item_id: item.id,
              item_name: item.name,
              discount: item.priceBeforeDiscountObject
                ? this.$helper.calculateDiscount(
                    item.priceBeforeDiscountObject.gross,
                    item.priceObject.gross,
                  )
                : 0,
              brand: item.brand ? item.brand.name : '',
              ...categories,
              item_list_id: slugify(this.listName),
              item_list_name: this.listName,
              price: item.priceObject.gross,
              variant: '',
              quantity: 1,
            },
          ],
        },
      });

      if (this.disableNativeLink) {
        this.$router.push(
          this.localePath({ name: 'product-slug', params: { slug: this.productData.slug } }),
        );
      }
    },
    async refreshTile(e) {
      this.isRefreshing = true;
      const result = await this.$axios.get(
        `${this.$config.baseOfixApi}/e-commerce/v1/products/${e.slug}`,
        {
          params: {
            includeBreadcrumbs: false,
            includeProduct: true,
            includeSeoData: false,
            includeAccessories: false,
            includeSimilarProducts: false,
            includeOtherProducts: false,
            includeOtherProductsWithSameBrand: false,
          },
          useCache: true,
        },
      );
      this.productData = result.data.product;
      if (
        typeof this.productData.gallery !== 'undefined' &&
        typeof this.productData.gallery.main !== 'undefined' &&
        typeof this.productData.gallery.main.urlFull !== 'undefined'
      ) {
        this.productData.mainPictureUrl = this.productData.gallery.main.urlFull;
      }
      this.isRefreshing = false;
    },
  },
};
</script>

<style lang="scss">
.productTile {
  $root: &;
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  &__inner {
    display: flex;
    flex-direction: column;
    position: relative;
    height: 100%;
    background-color: $cWhite;
    padding-bottom: 19rem;

    @include rwd('ultra') {
      padding-bottom: 18rem;
    }
  }

  &__link {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
  }

  &__header {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    display: flex;
    z-index: 1;
    padding: 2rem 2rem 0 2rem;
    justify-content: space-between;

    @include rwd('ultra') {
      padding: 2rem 1.5rem 1rem 2rem;
    }
  }

  &__headerBadgeWrapper {
    margin-top: 0.5rem;

    &:first-child {
      margin-top: 0;
    }
  }

  &__headerOffer {
    position: relative;
    display: flex;
    padding-bottom: 1rem;
    align-items: center;
    z-index: 2;
  }

  &__headerOfferText {
    padding-right: 0.5rem;
    font-size: 1.2rem;
    line-height: 2rem;
    color: $cMainNeutral;
  }

  &__image {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 23rem;
    width: 100%;
    padding: 3rem 2rem 0 2rem;

    @include rwd('ultra') {
      height: 21rem;
      padding: 1.5rem 1rem 0 2rem;
    }
  }

  &__imageImg {
    height: 100%;
  }

  &__content {
    position: absolute;
    padding: 2rem 2rem 0 2rem;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: $cWhite;
    //z-index: 1;
    transition: top $tr, box-shadow $tr, padding $tr;
  }

  &__ratings {
    margin-bottom: 0.7rem;
  }

  &__name {
    margin-bottom: 0.6rem;
    font-size: 1.4rem;
    line-height: 1.8rem;
    max-height: 4rem;
    overflow: hidden;
  }

  &__tags {
    margin-bottom: 1rem;
  }

  &__tag {
    padding-left: 1rem;
    padding-right: 1rem;
    color: $cAddDark02;
    font-size: 1.1rem;
    line-height: 1.8rem;
    border-left: 1px solid $cAddLight;
    text-transform: capitalize;

    &:first-child {
      border-left: 0;
    }

    b {
      font-family: $fSecond;
      font-weight: 500;
    }
  }

  &__price {
    display: flex;
    height: 9rem;
    flex-direction: column;
    justify-content: center;
    font-family: $fSecond;
    border-top: 1px solid $cAddLight;
  }

  &__priceRegular {
    font-size: 1.6rem;
    line-height: 2.2rem;
    color: $cMainNeutral;
  }

  &__priceRegularNumber {
    font-size: 2.2rem;
    line-height: 2.2rem;
    font-weight: 500;
  }

  &__pricePromo {
    text-align: center;
  }

  &__oldPrice {
    position: relative;
    display: flex;
    margin-bottom: 0.2rem;
    align-items: center;
    color: $cAddDark02;
    z-index: 2;
  }

  &__oldPriceNumber {
    display: flex;
    font-size: 1.6rem;
    line-height: 2.2rem;
    text-decoration: line-through;
  }

  &__oldPriceText {
    font-size: 1.4rem;
    line-height: 1.8rem;
  }

  &__oldPriceInfo {
    position: relative;
    top: -1.3rem;
    padding: 0.3rem 1.1rem;
    max-width: 23.5rem;
    background-color: $cDarkGrey;
    box-shadow: 0 2rem 1.5rem rgba($cMainDark, 0.16);
    border-radius: 0.5rem;
    font-size: 1.2rem;
    line-height: 2.4rem;
    color: $cWhite;
    z-index: $zPopup;

    @include rwd('ultra') {
      max-width: 16rem;
    }

    &:after {
      content: '';
      position: absolute;
      bottom: -0.8rem;
      left: 50%;
      width: 0;
      height: 0;
      border-left: 0.9rem solid transparent;
      border-right: 0.9rem solid transparent;
      border-bottom: 0.8rem solid $cDarkGrey;
      transform: translateX(-50%) rotate(180deg);
    }
  }

  &__priceUom {
    font-size: 1.1rem;
    color: $cMainNeutral;
  }

  &__priceInfo {
    padding-top: 0.5rem;
    font-size: 1.2rem;
    color: $cMainNeutral;
  }

  &__cart {
    position: relative;
    margin-left: -2rem;
    padding-left: 2rem;
    padding-right: 2rem;
    height: 0;
    width: calc(100% + 4rem);
    z-index: 2;
    transition: height $tr;

    .countInput__input {
      @include rwd('tablet') {
        width: 6.8rem;
      }

      @include rwd('small-tablet') {
        width: 8.8rem;
      }

      @include rwd('small-phone') {
        width: 6.8rem;
      }
    }
  }

  &__discount {
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 1.5rem;
    height: 1.9rem;
    background-color: $cBadgeProm;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: $cWhite;
    margin-right: 0.6rem;
    padding: 1px 0.6rem 0;
  }

  &__cartInner {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 1.6rem;
  }

  &__cartMultiPacks {
    margin-bottom: 1rem;
    flex: 0 0 100%;
    max-width: 100%;
  }

  &__cartInput {
    margin-right: 10px;
  }

  &__cartButton {
    white-space: nowrap;
    flex: 1;
    padding-left: 0;
    padding-right: 0;
  }

  &__loader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($cWhite, 0.7);
    z-index: 10;
  }

  &--mobile {
    #{$root}__inner {
      padding-bottom: 24rem;
    }

    #{$root}__cart {
      height: auto;
    }

    #{$root}__tags {
      margin-bottom: 0.8rem;
    }

    #{$root}__price {
      height: auto;
      padding: 0.7rem 0;
    }

    #{$root}__content {
      position: relative;
      margin-top: auto;
    }

    #{$root}__inner {
      @include rwd('ultra') {
        padding-bottom: 0;
      }
    }

    #{$root}__image {
      @include rwd('ultra') {
        height: 17rem;
        margin-top: 1.5rem;
      }

      &.productTile__image--largeMobile {
        @include rwd('tablet') {
          height: 23rem;
          margin-top: 2rem;
        }
      }
    }

    #{$root}__content {
      padding: 0.5rem 2.5rem 0 2.5rem;

      @include rwd('ultra') {
        padding: 0.5rem 2rem 0 2rem;
      }
    }
  }

  @media (hover: hover) {
    &:hover {
      #{$root}__content {
        box-shadow: 0 -10px 20px rgba(23, 25, 51, 0.1);
      }

      #{$root}__cart {
        height: 6.6rem;
      }

      #{$root}__content {
        padding: 2rem 2rem 0 2rem;

        @include rwd('laptop') {
          padding: 1rem 2rem 0 2rem;
        }
      }
    }

    &--multiPacks {
      &:hover {
        #{$root}__cart {
          height: 14.2rem;
        }
      }
    }
  }

  &--multiPacks {
    @media (hover: none) {
      #{$root}__cart {
        height: 12.5rem;
      }
    }
  }

  &--isFromMyOffer {
    #{$root}__inner {
      border: 1px solid $cMain;
      overflow: hidden;
    }

    #{$root}__price {
      border-top: 1px solid $cMain;
    }
  }
}
</style>
